import React from "react";
import useStyles from "../styles/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import driver from "../assets/img/driver-download.webp";
import { handleAppStoreClick } from "../common/appStoreUtils";

const DownloadApp = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);

  return (
    <div className={`${classes.bookaRideSection} ${classes.spacings}`}>
      <div className={classes.sectionImageContainer}>
        <img
          className={classes.sectionContainerImage}
          src={driver}
          alt="home"
        />
      </div>

      <div className={classes.bookRideTextContainer}>
        <h2 className={classes.h2SectionContainer}>{t("HarakaDriver")} </h2>

        <p className={classes.p1SectionContainer}>{t(`riderBenefit`)}</p>
        <button
          className={`${classes.buttonSectionContainer} ${classes.primaryBtn}`}
          onClick={handleAppStoreClick(
            settings,
            "/login?signup=rider",
            "driver"
          )}
        >
          {t(`downloadRider`)}
        </button>
      </div>
    </div>
  );
};

export default DownloadApp;
